export default __webpack_public_path__ + "static/DFI-logo-da-0cf0375958e6be3bedd20b618b07240d.png";